import React from 'react';
import { SubscriptionTileProps } from './types';
import { SubscribeButton } from './subscribe-button';
import styles from './subscription-tile.scss';

export const SubscriptionTile: React.FC<SubscriptionTileProps> = (props) => {

  const { option, changeHandler, valueItems = [], translation } = props;
  const checked = valueItems.some(item => item.value === option.value);

  return <div key={option.value} className="col-lg-6">
    <div className={styles.subscriptionTilesContainer}>
      <div className={styles.subscriptionTiles}>
        <div className={styles.subscriptionContent}>
          <SubscribeButton
            item={option}
            checked={checked}
            translation={translation}
            onChange={changeHandler} />
        </div>
      </div>
    </div>
  </div>;
};
